import { IS_PRODUCTION, STADIUM_USERS_URL } from "@constants/app-defaults";
import { BYSTADIUM_BOOK_A_CALL, BYSTADIUM_HOSTNAME } from "@stadium/helpers/app-routes";
import { stadium } from "@stadium/constants/brands";
import { BYSTADIUM_MARKETING_URL } from "@stadium/helpers/src/app-routes";

const MARKETING_APP_PRODUCTION_BASE_URL = "https://www.bystadium.com";
const MARKETING_APP_STAGING_BASE_URL = "https://dev.bystadium.com";

export const MARKETING_APP_BASE_URL = IS_PRODUCTION
  ? MARKETING_APP_PRODUCTION_BASE_URL
  : MARKETING_APP_STAGING_BASE_URL;

export const MARKETING_APP_BASE_HOSTNAME = new URL(MARKETING_APP_BASE_URL).hostname;

export const CUSTOM_DOMAIN_FORM_URL = "https://by-stadium.typeform.com/to/LT3i3Hb2";
export const SHOPS_DETAIL_MARKETING_PAGE = `${MARKETING_APP_BASE_URL}/all-shop-templates`;
export const BYSTADIUM_ZENDESK_URL = "https://bystadium.zendesk.com/hc/en-us";
export const BYSTADIUM_TERMS_OF_USE_URL = "https://www.bystadium.com/terms-of-use/";

export const FOOTER_LINKS = [
  {
    text: "FAQS",
    link: BYSTADIUM_ZENDESK_URL,
  },
  {
    text: "TERMS OF USE",
    link: BYSTADIUM_TERMS_OF_USE_URL,
  },
];

export const FAQ =
  "https://help.bystadium.com/hc/en-us/sections/27351348497687-Stadium-Points-Program";
export const CUSTOMIZATIONS_FAQ =
  "https://help.bystadium.com/hc/en-us/sections/27645793730071-Shop-Customization";
export const BYSTADIUM_RESOURCES_URL = "https://www.bystadium.com/resources";

export const LOGO_AUTH_TNC =
  "https://www.bystadium.com/terms-of-use/?_gl=1*4cix46*_gcl_au*NTkwMTkzMDQxLjE2OTYyNjcxMDI.#intellectual-property";

const STADIUM_ACCOUNTS_URL = STADIUM_USERS_URL;

export const STADIUM_CONTACTS_URL = `${STADIUM_ACCOUNTS_URL}/contacts`;
export const STADIUM_ACCOUNT_SETTING_URL = `${STADIUM_ACCOUNTS_URL}/settings`;
export const STADIUM_ACCOUNT_FEATURE_PACKAGES_URL = `${STADIUM_ACCOUNTS_URL}/feature-packages`;
export const STADIUM_ACCOUNT_TEAMS_URL = `${STADIUM_USERS_URL}/teams`;

export const BYSTADIUM_INTEGRATION_URL = "https://www.bystadium.com/integrations";

export const STADIUM_ZAPIER_INTEGRATION_URL = "https://zapier.com/apps/stadium/integrations";

export const BYSTADIUM_SSO_INFO_URL = "https://www.bystadium.com/sso";

export const BYSTADIUM_RECOGNITION_PROGRAM_URL = "https://www.bystadium.com/kudos-program";
export const BYSTADIUM_INTEGRATION_FEATURES_URL = `${BYSTADIUM_MARKETING_URL}/integrations`;

export const BYSTADIUM_INTEGRATION_URLS = {
  hris: `${BYSTADIUM_INTEGRATION_FEATURES_URL}/hris`,
  crm: `${BYSTADIUM_INTEGRATION_FEATURES_URL}/crm`,
  api: `${BYSTADIUM_INTEGRATION_FEATURES_URL}/api`,
};

export const THIRD_PARTY_APP_INTEGRATION_TYPEFORM_URL =
  "https://by-stadium.typeform.com/to/RI3vNY2F";

export const BOOK_A_CALL_URL = `${BYSTADIUM_BOOK_A_CALL}?sourceOrigin=${stadium.key}`;

export const OFFERINGS_PATH = `${BYSTADIUM_HOSTNAME}/go`;

export const OFFERINGS_SEND_ITEMS_PAGE_ROUTE = `${OFFERINGS_PATH}/senders-pick/send-items`;

export const CONTACT_SUPPORT = "https://help.bystadium.com/hc/en-us/requests/new";

export const LEARN_MORE_PERMISSIONS_URL =
  "https://help.bystadium.com/hc/en-us/articles/37464315734551-Understanding-Future-Admins-Senders-in-Your-Company-Space-Workspace";
